import { useEffect, useState } from "react";
import { sizes } from "@/styles/mediaQueries";

interface DeviceType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export function useScreenSize(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      const newDeviceType = {
        isMobile: width < sizes.screenSmMin,
        isTablet: width >= sizes.screenSmMin && width < sizes.screenMdMin,
        isDesktop: width >= sizes.screenMdMin,
      };

      // Only update if values actually changed
      setDeviceType((prev) => {
        if (
          prev.isMobile === newDeviceType.isMobile &&
          prev.isTablet === newDeviceType.isTablet &&
          prev.isDesktop === newDeviceType.isDesktop
        ) {
          return prev; // No change, don't trigger re-render
        }
        return newDeviceType;
      });
    };

    // Initial check
    updateDeviceType();

    // Add resize listener
    window.addEventListener("resize", updateDeviceType);

    // Cleanup
    return () => window.removeEventListener("resize", updateDeviceType);
  }, []);

  return deviceType;
}
